// ── Opening the keyboard without the wait (Jade, 2026-10-11) ────────────────
// Two causes of the Android app's keyboard opening later than in a browser:
//
// 1. Capacitor's Keyboard.show() waits 350ms on purpose before asking Android
//    for the keyboard (KeyboardPlugin.show: postDelayed 350). The Planner
//    quick-add bar and the Clock-In note bar both leaned on it, so their
//    keyboard always came up a third of a second late. showKeyboardNow() asks
//    straight away (ClarityBars.showKeyboard), falling back to Keyboard.show()
//    on a build without that method.
//
// 2. A WebView only opens the keyboard for a field focused *during a tap*. Bars
//    and panels that focus their field after they render (an effect, a frame
//    later) are outside the tap, so nothing opened it until (1) kicked in.
//    primeKeyboard() is called from the opening tap itself: it focuses a tiny
//    invisible field right away so the keyboard starts opening with the tap,
//    and the real field takes the focus over once it's on screen (moving focus
//    between fields keeps the keyboard up). If nothing takes it over, the
//    primer lets go after a second so the keyboard doesn't stay open for nothing.
import { Capacitor, registerPlugin } from "@capacitor/core";
import { Keyboard } from "@capacitor/keyboard";

const isNative = Capacitor.isNativePlatform();
const ClarityBars = registerPlugin("ClarityBars");
const coarse = typeof window !== "undefined" && window.matchMedia && window.matchMedia("(pointer: coarse)").matches;

export function showKeyboardNow() {
  if (!isNative) return;
  ClarityBars.showKeyboard().catch(() => Keyboard.show().catch(() => {}));
}

let primer = null;
export function primeKeyboard() {
  if (!coarse || typeof document === "undefined") return;
  if (!primer) {
    primer = document.createElement("input");
    primer.type = "text";
    primer.setAttribute("aria-hidden", "true");
    primer.tabIndex = -1;
    // Top of the screen (so the window never pans to it), invisible, 16px text
    // (smaller makes iOS zoom in).
    primer.style.cssText = "position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;border:0;padding:0;font-size:16px;pointer-events:none;";
    document.body.appendChild(primer);
  }
  try { primer.focus({ preventScroll: true }); } catch (_) { return; }
  const p = primer;
  setTimeout(() => { if (document.activeElement === p) p.blur(); }, 1000);
}
